module.exports = "<div ng-bind-html=\"vm.trustedHtml(vm.main.value)\"></div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./app/shared/directives/accesssibility/directives/functionality.html
 ** module id = 159
 ** module chunks = 0
 **/